import Suggestions from './Suggestions'

export default [
  { path: '/suggestions', name: 'suggestions', component: Suggestions }
]



// WEBPACK FOOTER //
// ./src/components/suggestions/routes.js